    <script>
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    nome: 'novo-leiloeiro',
    directives: {mask},
    data () {
      return {
        isLoading: false
      }
    },
    computed: {},
    mounted () {
    },
    activated () {
    },
    destroyed () {
//      console.log('destruido')
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      }
    }
  }
</script>

<template>
    <div>
        <div class="app-content-body ">
            <div class="bg-light lter b-b wrapper-md">
              <h1 class="m-n font-thin h3">Cadastro de Leiloeiro</h1>
            </div>
            <div class="wrapper-md">
                <div class="panel panel-default">
                    <form>
                        <div class="form-group wrapper-md">
                            <div class="row m-b-md">
                                <div class="col-md-8">
                                    <label for="" class="control-label">Nome</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                                <div class="col-md-4">
                                    <label class="control-label">Telefone</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                            </div><!-- Fim Row -->
                            <div class="row m-b-md">
                                <div class="col-md-4">
                                    <label for="" class="control-label">Cidade</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                                <div class="col-md-4">
                                    <label class="control-label">Bairro</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label">Uf</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label">Número</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                            </div><!-- Fim Row -->
                            <div class="row m-b-xs">
                                <div class="col-md-4">
                                    <label for="" class="control-label">Cidade</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                                <div class="col-md-4">
                                    <label class="control-label">Complemento</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label">Cep</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label">Fax</label>
                                    <input id="" type="" class="form-control" placeholder="">
                                </div>
                            </div><!-- Fim Row -->
                            <hr>
                            <div class="wrapper-md">
                            <div class="row">
                                <button class="btn w-xs m-r-md btn-default">Cancelar</button>
                                <button class="btn w-xs btn-info">Cadastrar</button>
                            </div>
                        </div>
                        </div>                        
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// NovoLeiloeiro.vue?3340c362